(() => {
  "use strict";
  const root=document.getElementById("ad-shop");
  if(!root)return;
  const modal=root.querySelector("#ad-legal-dialog");
  if(!modal)return;
  const docs=Array.from(modal.querySelectorAll("[data-legal-document]"));
  let trigger=null;
  root.querySelectorAll("[data-legal-open]").forEach(button=>{
    button.addEventListener("click",()=>{
      const id=button.getAttribute("data-legal-open");
      const chosen=docs.find(doc=>doc.dataset.legalDocument===id);
      if(!chosen)return;
      docs.forEach(doc=>{doc.hidden=doc!==chosen;});
      trigger=button;
      if(typeof modal.showModal==="function")modal.showModal();
    });
  });
  modal.querySelectorAll(".ad-legal-dialog-close").forEach(b=>b.addEventListener("click",()=>modal.close()));
  modal.addEventListener("click",event=>{if(event.target===modal)modal.close()});
  modal.addEventListener("close",()=>{
    docs.forEach(doc=>doc.hidden=true);
    if(trigger&&document.contains(trigger))trigger.focus();
    trigger=null;
  });
})();